import type {
  Filters,
  SnapshotId,
  TableRequestBody,
  TableResponseBody,
} from '@ipfabric/utils';

import type { ApiRequestFunction } from 'utils/request/useApi';
import type { StpInstanceData } from '../TopologyLayoutSettingsProtocolsProtocol/useStpInstances';

export const fetchStpInstances = async (
  apiRequest: ApiRequestFunction,
  start: number,
  limit: number,
  filters: Filters,
  snapshotId: SnapshotId,
): Promise<TableResponseBody<StpInstanceData>> =>
  apiRequest<
    TableResponseBody<StpInstanceData>,
    TableRequestBody<StpInstanceData>
  >({
    url: '/tables/spanning-tree/instance-members',
    method: 'POST',
    data: {
      columns: ['id', 'rootHostname', 'rootId', 'vlanId', 'vlanName'],
      filters,
      pagination: { limit, start },
      snapshot: snapshotId,
    },
  });
